import React from 'react'
import {injectIntl} from 'react-intl'
import FormControl from '@mui/material/FormControl'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import Button from '@mui/material/Button'
import Select from '@mui/material/Select'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import TextField from '@mui/material/TextField'
import Dialog from 'components/Dialog'

class QuestionDialog extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            field: props.data ? props.data.field : props.options[0].id,
            positive: props.data ? props.data.positive : 'Text for positive answer',
            negative: props.data ? props.data.negative : 'Text for negative answer'
        }
    }

    handleChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        })
    }

    handleDelete = () => {
        this.props.handleEditorUpdate(this.props.id)
        this.props.handleClose()
    }

    handleEdit = () => {
        const obj = {
            field: this.state.field,
            positive: this.state.positive,
            negative: this.state.negative
        }

        if (this.props.data) {
            this.props.handleEditorUpdate(this.props.id, obj)
        } else {
            this.props.insertBlock(this.props.type, obj)
        }

        this.props.handleClose()
    }

    render() {
        const {intl} = this.props
        const invalid = !this.state.negative || !this.state.positive

        return (
            <Dialog open={this.props.open} onClose={this.props.handleClose}>
                <DialogTitle>
                    {intl.formatMessage({id: "editor.question_settings"})}
                </DialogTitle>
                <DialogContent>
                    <TextField variant="standard"
                        sx={{
							width: '100%',
							marginBottom: '20px'
						}}
                        value={this.state.positive}
                        onChange={this.handleChange}
                        label={intl.formatMessage({id: "editor.positive_answer_label"})}
                        InputLabelProps={{
                            shrink: true
                        }}
                        inputProps={{
                            name: 'positive'
                        }}
                    />
                    <TextField variant="standard"
                        sx={{
							width: '100%',
							marginBottom: '20px'
						}}
                        value={this.state.negative}
                        onChange={this.handleChange}
                        label={intl.formatMessage({id: "editor.negative_answer_label"})}
                        InputLabelProps={{
                            shrink: true
                        }}
                        inputProps={{
                            name: 'negative'
                        }}
                    />
                    <FormControl sx={{width: '100%'}} variant="standard">
                        <InputLabel>
                            {intl.formatMessage({id: "editor.logical_field"})}
                        </InputLabel>
                        <Select
                            value={this.state.field}
                            onChange={this.handleChange}
                            inputProps={{
                                name: 'field'
                            }}
                        >
                            {this.props.options.map(item =>
                                <MenuItem key={item.id} value={item.id}>
                                    {item.singular}
                                </MenuItem>
                            )}
                        </Select>
                    </FormControl>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.props.handleClose} color="primary">
                        {intl.formatMessage({id: "app.confirm_cancel"})}
                    </Button>
                    {this.props.data &&
                        <Button onClick={this.handleDelete}
                            variant="contained"
                            color="secondary"
                        >
                            {intl.formatMessage({id: "app.confirm_delete"})}
                        </Button>
                    }
                    <Button onClick={this.handleEdit} disabled={invalid} variant="contained" color="primary">
                        {intl.formatMessage({id: "app.confirm_save"})}
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }
}

export default injectIntl(QuestionDialog)
